import { Observable, OperatorFunction } from 'rxjs';
import { map } from 'rxjs/operators';

/**
 * Replace all properties equal to an empty string with `undefined` if given object is a real object.
 *
 * @param debug - If `true` logs the object before and after transformation
 */
export function replaceEmptyStrings<T>(debug = false): OperatorFunction<T, T> {
  return function (source: Observable<T>): Observable<T> {
    return source.pipe(
      map(payload => {
        if (payload && typeof payload === 'object') {
          const entries = Object.entries(payload).map(([key, value]) => {
            const replaced = typeof value === 'string' && value === '' ? undefined : value;
            return [key, replaced];
          });
          const cleaned = Object.fromEntries(entries) as T;
          if (debug) {
            console.log('Before:', payload);
            console.log('After:', cleaned);
          }
          return cleaned;
        }
        return payload;
      }),
    );
  };
}
